import React, { useState, useEffect } from "react";
import NavBar from './NavBar';
import { Link, useLocation } from 'react-router-dom';
import {FaTimes } from 'react-icons/fa';
import './HomePage.css';
import './Services';
import './Sectors';
import './ChinaFocus';
import './IndiaFocus';
import './Technology';
import './CoreValues';
import './Resources';
import './PrivacyPolicy';
import './TermsOfService';
import './ContactUs';
import { FaUsers, FaIndustry, FaChalkboardTeacher, FaGlobe, FaBars } from 'react-icons/fa';
import abt_first from './assets/images/about-us-first-image-1-scaled.jpg';
import logo from './assets/images/favicon1.webp';
import logo1 from './assets/images/0040C0.png';
import adobe_stock from './assets/images/AdobeStock_265613983-scaled.jpeg';
import abt_last from './assets/images/About-US-Page-last-image-at-bottom.jpg';

function HomePage() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
   
      useEffect(() => {
          document.title = "Bay Capital Advisors – Strategic Advisory Services";
          
          // Find and update the favicon
          let favicon = document.querySelector("link[rel~='icon']");
          if (!favicon) {
            favicon = document.createElement('link');
            favicon.rel = 'icon';
            document.head.appendChild(favicon);
          }
          favicon.href = logo; // Use your logo as favicon
          
          return () => {
            // Reset title when component unmounts if needed
            document.title = "Bay Capital Advisors";
          };
        }, []);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  return (
    <div className="homepage">
      {/* Mobile Menu Button */}
      <div className="mobile-menu-button" onClick={toggleMobileMenu}>
        {isMobileMenuOpen ? <FaTimes /> : <FaBars />}
      </div>
      
      {/* Mobile Menu Dropdown */}
      {isMobileMenuOpen && (
        <div className="mobile-dropdown-overlay" onClick={closeMobileMenu}>
          <div className="mobile-dropdown" onClick={(e) => e.stopPropagation()}>
            <NavBar isMobile={true} closeMenu={closeMobileMenu} />
          </div>
        </div>
      )}

      <section className="hero">
        <header className="header">
          <NavBar isMobile={false} />
        </header>

        <div className="hero-content">
          <h1>Bay Capital Advisors is a boutique strategic advisory firm facilitating emerging growth and middle market companies with their growth expansion strategies.</h1>
          <div className="hero-image"></div>
        </div>
      </section>

      {/* About Section */}
      <section className="about">
      <div className="about-content">
            <p className="about-paragraph">
            Bay Capital Advisors advises companies across a narrow spectrum of sectors and geographic markets, including technology, e-commerce, consumer products, fashion, retail, business to business services, fintech, life sciences, healthcare, food and beverage, chemicals and industrials. Geographically, we have considerable expertise in China, India, and European transactions. We have dedicated teams focused on individual sectors and relationships in certain foreign markets.
            </p>
        </div>
        <div className="about-image">
            
            <img src={abt_first} alt="About us image" className="city-image" />
        </div>
      </section>

  {/* Team Section */}
    <section className="team" id="team">
      <div className="team-heading">
        <p>TEAM OF EXPERIENCED BANKERS AND FORMER CORPORATE EXECUTIVES</p>
      </div>

      <div className="team-content-wrapper">
        {/* First Part: Image on Left, Text on Right */}
        <div className="team-section-part">
          <div className="image-overlay">
          <img src={adobe_stock} alt="Team working on computer" className="team-image zoom-effect"/>
          </div>
          <div className="team-content">
            <p>
            Bay Capital Advisors® is a leading boutique advisory firm specializing in capital financings and mergers and acquisitions for high growth industries.  Since 2001, our team has created tremendous shareholder value and wealth for our clients.
            </p>
          </div>
        </div>

        {/* Second Part: Text on Left, Image on Right */}
        <div className="team-section-part1">
        <div className="image-overlay1">
        <img src={abt_last} alt="Business meeting" className="team-image1 zoom-effect"/>
        </div>
          <div className="team-content1">
            <p>
            We are dedicated to strategic advisory services that achieve greater shareholder value and enhance the competitiveness and operational effectiveness of our clients in the global marketplace.
            </p>
          </div>
        </div>
      </div>
    </section>

    {/* Header Section */}
     
     <div className="header-section">
        <div className="header-overlay">
          <h1>SERVICES AT BAY CAPITAL ADVISORS</h1>
          <p>Highest quality advice and execution expertise to corporate executives, managers, and shareholders.</p>
        </div>
      </div>

      {/* Services Section */}
      <div className="services-section">
        <div className="service-card">
          <div className="card-inner">
            <div className="card-front">
            <div className="icon-circle">
              <FaUsers className="service-icon" />
            </div>
              <p className="service-title">Experienced Team</p>
            </div>
            <div className="card-back">
              <p>We have extensive transactional experience and deep expertise in investment banking, finance, management, strategy, and operations: decades of cumulative team experience in working on a number of transactions. Our team is comprised of experienced and seasoned representatives and brings a wealth of financial and industry expertise that our clients rely on to guide them through their most important and complex strategic decisions.</p>
            </div>
          </div>
        </div>
        <div className="service-card1">
          <div className="card-inner1">
            <div className="card-front">
              <div className="icon-circle">
                <FaIndustry className="service-icon" />
              </div>
              <p className="service-title">Industry Experts</p>
            </div>
            <div className="card-back1">
              <p>Our team has advised a number of leading early stage and middle market companies across a broad range of industries. In-depth industry knowledge enables Bay Capital Advisors to have high impact on client assignments. Our approach is to take a deep interest in the business of our clients’.</p>
            </div>
          </div>
        </div>
        <div className="service-card">
          <div className="card-inner">
            <div className="card-front">
              <div className="icon-circle">
                <FaChalkboardTeacher className="service-icon" />
              </div>
              <p className="service-title">Senior Attention</p>
            </div>
            <div className="card-back2">
              <p>Our experienced professionals are directly involved in all of our engagements. Our senior professionals have a breadth of experience unmatched in early stage and middle market enterprises, providing effective and diligent leadership on every transaction.</p>
            </div>
          </div>
        </div>
        <div className="service-card1">
          <div className="card-inner1">
            <div className="card-front">
              <div className="icon-circle">
                <FaGlobe className="service-icon" />
              </div>
              <p className="service-title">Global Reach</p>
            </div>
            <div className="card-back1">
              <p>Our industry and geographic specialization allows us to quickly gain an understanding of our clients' industry and operating environment, the markets they serve, and their competitive position, ultimately maximizing value for the owners of the enterprise.</p>
            </div>
          </div>
        </div>
      </div>
    {/* Footer Section */}
    <div className="footer-section">
        <nav>
          <a href="/CoreValues">Core Values</a>
          <a href="/Resources">Resources</a>
          <a href="/ContactUs">Contact Us</a>
        </nav>
        <div className="footer-logo">
        {/* <img src={logo1} alt="Bay Capital Advisors Logo" class="logo" /> */}
        <Link to="/"> {/* Add this Link wrapper */}
          <img src={logo1} alt="Bay Capital Advisors Logo" className="logo" />
        </Link>
        </div>
        <nav>
          <a href="/PrivacyPolicy">Privacy Policy</a>
          <a href="/TermsOfService">Terms of Service</a>
        </nav>
      </div>
    </div>
    
  );
}

export default HomePage;